import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-empty-history-table',
    templateUrl: './empty-history-table.component.html',
    styleUrls: ['./empty-history-table.component.scss'],
    standalone: false,
})
export class EmptyHistoryTableComponent {
    @Input() filter = '';
}
